import classnames from "classnames";
import React from "react";

import capitalise from "../../utils/capitalise";
import * as styles from "./Svg.module.css";

export const Svg = ({
  className,
  fill,
  hexFill,
  stroke,
  strokeWidth = "0.5",
  strokeColor,
  width,
  height,
  viewBox,
  top,
  left,
  bottom,
  right,
  translate,
  rotate,
  margin,
  flip,
  flipY,
  zIndex = "1",
  children,
  mobile,
  desktop,
  image,
  imageUrl,
  name,
  position,
  extendWidth,
  extendHeight,
  pulse,
  isMobile,
  mask,
}) => {
  const classes = classnames(className, {
    [styles.mobile]: mobile,
    [styles.desktop]: desktop,
    [`fill${capitalise(fill)}`]: fill,
    [`stroke${capitalise(stroke)}`]: stroke,
  });

  let inner = children;

  if (image || imageUrl) {
    inner = (
      <defs>
        <clipPath id={name} clipPathUnits="userSpaceOnUse">
          {children}
        </clipPath>
      </defs>
    );
  }
  if (mask) {
    inner = (
      <>
        <defs>
          <mask id="mask" x="0" y="0" width="100%" height="100%">
            {children}
          </mask>
        </defs>
        <rect x="0" y="0" width="100%" height="100%" />
      </>
    );
  }

  const render = (
    <svg
      style={{
        position: position || "absolute",
        top: top ? top : bottom ? "auto" : "0",
        left: left ? left : right ? "auto" : "0",
        bottom,
        right,
        width,
        height,
        zIndex,
        transform: `${translate ? `translate3d(${translate}, 0)` : ""} ${
          rotate ? `rotate(${rotate})` : ""
        } ${flip ? `scaleX(-1)` : ""} ${flipY ? `scaleY(-1)` : ""} ${
          pulse || isMobile ? `scale(0.8)` : `scale(1)`
        }`,
        overflow: "visible",
        margin: margin || "0",
        fill: hexFill,
        stroke: strokeColor,
      }}
      className={classes}
      strokeWidth={strokeWidth}
      fill="transparent"
      viewBox={viewBox}
      preserveAspectRatio="xMinYMax meet"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      {inner}
      {(image || imageUrl) && (
        <g
          style={{
            clipPath: `url(#${name})`,
          }}
        >
          <image
            width={extendWidth && "100%"}
            height={extendHeight && "100%"}
            xlinkHref={image?.file.url || imageUrl}
            style={{
              transform: `rotate(calc(-1 * ${rotate}))`,
              transformOrigin: "50%",
            }}
          />
        </g>
      )}
    </svg>
  );

  return render;
};
